var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 6.5V9.5C11.0996 9.76522 10.9943 10.0196 10.8067 10.2071C10.6192 10.3946 10.3648 10.5 10.0996 10.5H3.09961C2.83439 10.5 2.58004 10.3946 2.3925 10.2071C2.20497 10.0196 2.09961 9.76522 2.09961 9.5V2.5C2.09961 2.23478 2.20497 1.98043 2.3925 1.79289C2.58004 1.60536 2.83439 1.5 3.09961 1.5H6.09961M11.0996 1.5L6.59961 6M11.0996 1.5H8.09961M11.0996 1.5V4.5",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 6.5V9.5C11.0996 9.76522 10.9943 10.0196 10.8067 10.2071C10.6192 10.3946 10.3648 10.5 10.0996 10.5H3.09961C2.83439 10.5 2.58004 10.3946 2.3925 10.2071C2.20497 10.0196 2.09961 9.76522 2.09961 9.5V2.5C2.09961 2.23478 2.20497 1.98043 2.3925 1.79289C2.58004 1.60536 2.83439 1.5 3.09961 1.5H6.09961M11.0996 1.5L6.59961 6M11.0996 1.5H8.09961M11.0996 1.5V4.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIcon);
export default __webpack_public_path__ + "static/media/squareIcon.ede6ae1adb50c7d7b1484c9709d44deb.svg";
export { ForwardRef as ReactComponent };